import {useContext} from 'solid-js'
import { ReminderProviderBehavior } from './ReminderProvider'
import { ReminderContext } from './ReminderContext'

export function useReminder() {
    const contextValue: ReminderProviderBehavior = useContext(ReminderContext)
    if (!contextValue) {
        throw new Error(
            'could not find redux context value; please ensure the component is wrapped in a <ReduxProvider>'
        )
    }
    return contextValue
}
